import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useProjectOverview(projectId) {
    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}/overview`)
    return {
        projectOverview: data,
        mutateProjectOverview: mutate,
        isLoadingProjectOverview: !error && !data,
        isErrorProjectOverview: error
    }
}